export const ACTIVE_STATUS = 'ACTIVE';
export const BLOCKED_STATUS = 'BLOCKED';